// Email verification landing — ports auth.js _handleVerifyEmailToken.
// Opened from the link in the verification email (/verify-email?token=JWT).
// Posts the token, then routes to /login with a status message.

import { useEffect, useRef, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { authApi } from '../../api/auth'
import s from '../auth.module.css'

export default function VerifyEmail() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [status, setStatus] = useState('pending') // pending | ok | error
  const [message, setMessage] = useState('')
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return // StrictMode double-invoke guard — verify once
    ran.current = true

    if (!token) {
      setStatus('error')
      setMessage('Ссылка недействительна.')
      return
    }
    authApi
      .verifyEmailToken({ token })
      .then(() => {
        setStatus('ok')
        setMessage('Email подтверждён! Теперь вы можете войти.')
      })
      .catch((err) => {
        setStatus('error')
        setMessage(err.body?.detail || err.message || 'Ошибка подтверждения email')
      })
  }, [token])

  return (
    <div className={s.screen}>
      <div className={s.content}>
        <div className={s.header}>
          <h1 className={s.title}>Подтверждение email</h1>
          {status === 'pending' && <p className={s.subtitle}>Проверяем...</p>}
          {status === 'ok' && <p className={s.success}>{message}</p>}
          {status === 'error' && <p className={s.error}>{message}</p>}
        </div>

        {status === 'pending' && <div className={s.spinner} />}

        {status !== 'pending' && (
          <Link className={s.button} to="/login" style={{ textDecoration: 'none' }}>
            Войти
          </Link>
        )}
      </div>
    </div>
  )
}
